import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  // 单词类
  "登录":"Login",
  "公司":"Company",
  "主页":"HOME",
  "设定":"SETTING",
  "退出":"LOGOUT",
  "努力加载中":"Loading",
  "全部":"All",
  "":"",
  "":"",
  "":"",
  // element多语言
  ...enLocale
}

export default en
